import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";
export default function ConsultationRequestForm({

    consultation,
    message,
    errors = {},
    consultants = [],
    specialites = [],
    activityProfs = [],
    wilayas = [],
    consultantFilters = {},
    onChange,
    onFilterChange,
    onSearchConsultants,

    onSubmit,
    onCancel,
    loading = false


}) {
    const { t } = useTranslation();
    const { language } = useLanguage();

    const fileInputRefs = useRef([]);
    const openFileChooser = (index) => {
        fileInputRefs.current[index]?.click();
    };

    return (
        <form onSubmit={onSubmit} encType="multipart/form-data">
            <div className="card shadow-sm border-0">
                {/* ====================================== */}
                {/* HEADER                                 */}
                {/* ====================================== */}
                <div className="card-header bg-success text-white">
                    <h5 className="mb-0">
                        <i className="bi bi-chat-dots me-2"></i>
                        {t("button.create")}
                    </h5>
                </div>

                {/* ====================================== */}
                {/* BODY                                   */}
                {/* ====================================== */}

                <div className="card-body">
                    <h5 className="text-success mb-3">

                        {t("consultationRequest.requestInfo")}
                    </h5>
                    {/* Type */}

                    <div className="mb-3">
                        <label className="form-label required-label">
                            {t("consultationRequest.wishToConsult")}
                        </label>
                        <select
                            className={`form-select ${errors.consultationType ? "is-invalid" : ""
                                }`}
                            name="consultationType"
                            value={consultation.consultationType || ""}
                            onChange={onChange}
                        >
                            <option value="">
                                {t("consultant.search.select")}
                            </option>

                            <option value="L">
                                {t("consultant.types.livestock")}
                            </option>

                            <option value="C">
                                {t("consultant.types.agriculture")}
                            </option>

                        </select>

                        {errors.consultationType && (
                            <div className="text-danger mt-1">
                                {errors.consultationType}
                            </div>
                        )}

                    </div>

                    {/* Consultant */}

                    <div className="mb-4">
                        <label className="form-label required-label">
                            {t("consultant.card.consultant")}
                        </label>

                        {/* **************************************** */}
                        {/* FILTRES CONSULTANTS                      */}
                        {/* **************************************** */}

                        <h5 className="text-success mb-3">
                            {t("consultationRequest.consultantSearch")}
                        </h5>

                        <div className="row">

                            {/* Activité professionnelle */}

                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    {t("menu.activityProf")}
                                </label>

                                <select
                                    className="form-select"
                                    name="idActivityProf"
                                    value={consultantFilters.idActivityProf || ""}
                                    onChange={onFilterChange}
                                >

                                    <option value="">
                                        {t("consultant.filters.all")}
                                    </option>

                                    {

                                        activityProfs.map(a => (

                                            <option
                                                key={a.id}
                                                value={a.id}
                                            >
                                                {getLabel(a, "activityProf", language)}
                                            </option>

                                        ))

                                    }

                                </select>

                            </div>


                            {/* Spécialité */}

                            <div className="col-md-4 mb-3">

                                <label className="form-label">

                                    {t("menu.speciality")}

                                </label>

                                <select
                                    className="form-select"
                                    name="idSpecialite"
                                    value={consultantFilters.idSpecialite || ""}
                                    onChange={onFilterChange}
                                >

                                    <option value="">
                                        {t("consultant.filters.all")}
                                    </option>

                                    {

                                        specialites.map(s => (

                                            <option
                                                key={s.id}
                                                value={s.id}
                                            >

                                                {getLabel(s, "specialite", language)}

                                            </option>

                                        ))

                                    }

                                </select>

                            </div>


                            {/* Wilaya */}

                            <div className="col-md-4 mb-3">

                                <label className="form-label">

                                    {t("menu.wilaya")}

                                </label>

                                <select
                                    className="form-select"
                                    name="idWilaya"
                                    value={consultantFilters.idWilaya || ""}
                                    onChange={onFilterChange}
                                >

                                    <option value="">
                                        {t("consultant.filters.all")}
                                    </option>

                                    {

                                        wilayas.map(wilaya => (

                                            <option
                                                key={wilaya.id}
                                                value={wilaya.id}
                                            >
                                                {getLabel(wilaya, "wilaya", language)}

                                            </option>

                                        ))

                                    }

                                </select>

                            </div>

                        </div>


                        <div className="text-end mb-4">

                            <button

                                type="button"

                                className="btn btn-outline-success"

                                onClick={onSearchConsultants}

                            >

                                <i className="bi bi-search me-2"></i>
                                {t("button.search")}
                            </button>

                        </div>

                        <hr />

                        <select

                            className={`form-select ${errors.receiver ? "is-invalid" : ""
                                }`}

                            value={consultation.receiver?.id || ""}

                            onChange={(e) =>

                                onChange({

                                    target: {

                                        name: "receiver",

                                        value: {
                                            id: Number(e.target.value)
                                        }

                                    }

                                })

                            }
                        >
                            <option value="">
                                {t("consultant.filters.choose")}
                            </option>

                            {

                                consultants.map(c => (

                                    <option
                                        key={c.id}
                                        value={c.id}
                                    >

                                        {c.fullName}

                                    </option>

                                ))

                            }

                        </select>

                        {

                            errors.receiver &&

                            <div className="text-danger mt-1">

                                {errors.receiver}

                            </div>

                        }

                    </div>

                    <hr />

                    {/* **************************************** */}
                    {/* PREMIER MESSAGE                         */}
                    {/* **************************************** */}

                    {/* Objet */}

                    <div className="mb-3">
                        <label className="form-label required-label">
                            {t("consultationRequest.subject")}
                        </label>
                        <input
                            type="text"
                            className={`form-control ${errors.consultationObject ? "is-invalid" : ""
                                }`}
                            name="consultationObject"

                            value={consultation.consultationObject || ""}

                            onChange={onChange}

                        />

                        {

                            errors.consultationObject &&

                            <div className="text-danger mt-1">

                                {errors.consultationObject}

                            </div>

                        }

                    </div>


                    {/* Corps */}
                    <div className="mb-4">

                        <label className="form-label required-label">
                            {t("messageComposer.message")}
                        </label>

                        <textarea

                            rows="7"

                            className={`form-control ${errors.messageBody ? "is-invalid" : ""
                                }`}

                            name="messageBody"

                            value={message.messageBody || ""}

                            onChange={onChange}

                        />

                        {

                            errors.messageBody &&

                            <div className="text-danger mt-1">

                                {errors.messageBody}

                            </div>

                        }

                    </div>

                    <hr />

                    {/* **************************************** */}
                    {/* PIECES JOINTES                          */}
                    {/* **************************************** */}

                    <h5 className="text-success mb-3">
                        {t("common.attachments")}
                    </h5>

                    <div className="row">
                        <input
                            ref={(el) => (fileInputRefs.current[0] = el)}
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.mp4"
                            name="attachedFile1"
                            onChange={onChange}
                        />

                        <div className="input-group">

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => openFileChooser(0)}
                            >
                                <i className="bi bi-paperclip me-2"></i>
                                {t("common.chooseFile")}
                            </button>

                            <span className="form-control text-start">

                                {
                                    message.attachedFile1
                                        ? (
                                            <>
                                                <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                                                {message.attachedFile1.name}
                                            </>
                                        )
                                        : (
                                            <span className="text-muted">
                                                {t("common.noAttachment")}
                                            </span>
                                        )
                                }

                            </span>

                        </div>
                        <input
                            ref={(el) => (fileInputRefs.current[1] = el)}
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.mp4"
                            name="attachedFile2"
                            onChange={onChange}
                        />

                        <div className="input-group">

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => openFileChooser(1)}
                            >
                                <i className="bi bi-paperclip me-2"></i>
                                {t("common.chooseFile")}
                            </button>

                            <span className="form-control text-start">

                                {
                                    message.attachedFile2
                                        ? (
                                            <>
                                                <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                                                {message.attachedFile2.name}
                                            </>
                                        )
                                        : (
                                            <span className="text-muted">
                                                {t("common.noAttachment")}
                                            </span>
                                        )
                                }

                            </span>

                        </div>

                        <input
                            ref={(el) => (fileInputRefs.current[2] = el)}
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.mp4"
                            name="attachedFile3"
                            onChange={onChange}
                        />
                        <div className="input-group">

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => openFileChooser(2)}
                            >
                                <i className="bi bi-paperclip me-2"></i>
                                {t("common.chooseFile")}
                            </button>

                            <span className="form-control text-start">

                                {
                                    message.attachedFile3
                                        ? (
                                            <>
                                                <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                                                {message.attachedFile3.name}
                                            </>
                                        )
                                        : (
                                            <span className="text-muted">
                                                {t("common.noAttachment")}
                                            </span>
                                        )
                                }

                            </span>

                        </div>
                        <input
                            ref={(el) => (fileInputRefs.current[3] = el)}
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.mp4"
                            name="attachedFile4"
                            onChange={onChange}
                        />

                        <div className="input-group">

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => openFileChooser(3)}
                            >
                                <i className="bi bi-paperclip me-2"></i>
                                {t("common.chooseFile")}
                            </button>

                            <span className="form-control text-start">

                                {
                                    message.attachedFile4
                                        ? (
                                            <>
                                                <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                                                {message.attachedFile4.name}
                                            </>
                                        )
                                        : (
                                            <span className="text-muted">
                                                {t("common.noAttachment")}
                                            </span>
                                        )
                                }

                            </span>

                        </div>

                    </div>
                </div>
                {/* ====================================== */}
                {/* FOOTER                                 */}
                {/* ====================================== */}

                <div className="card-footer">
                    <div className="d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onCancel}
                        >
                            {t("button.cancel")}
                        </button>
                        <button
                            type="submit"
                            className="btn btn-success"
                            disabled={loading}
                        >

                            {
                                loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Enregistrement...
                                    </>
                                    :
                                    <>
                                        <i className="bi bi-send-fill me-2"></i>
                                       {t("button.send")}
                                    </>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
}